import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=1df3120e&scoped=true"
import script from "./ProductsChart.vue?vue&type=script&lang=js"
export * from "./ProductsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3120e",
  null
  
)

export default component.exports